import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i793476407__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Haus", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i793476407__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M109.19 96.08h16v16h-16z",
      style: {"fill":"none"}
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M96.02 9.26a4.004 4.004 0 0 0-5.66 0L9.17 90.44l5.66 5.66 14.36-14.36V180h8V73.74l56-56 56 56V180h8V81.74l14.36 14.36 5.66-5.66z",
      class: "i793476407__cls-2"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M77.19 148.08V180h8v-27.92h16V180h8v-31.92c0-2.21-1.79-4-4-4h-24c-2.21 0-4 1.79-4 4M129.19 88.08h-24c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4v-24c0-2.21-1.79-4-4-4m-4 24h-16v-16h16z",
      class: "i793476407__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "house"}) } }